import { Camera, ArrowClockwise, Target } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { StaggerGroup, StaggerItem } from './ScrollReveal';

const ICONS = [ArrowClockwise, Camera, Target];

/**
 * Highlights strip — ds/card/landing-highlight--on-surface (.pen).
 */
export function LandingHighlights() {
  return (
    <section className="bg-sage-50 py-space-16 dark:bg-[#20261E] mid:py-space-16 wide:py-space-24">
      <StaggerGroup
        className="mx-auto grid max-w-[1120px] grid-cols-1 gap-space-4 px-space-5 mid:grid-cols-3 mid:gap-space-6 mid:px-space-10 wide:gap-space-6 wide:px-space-20"
        stagger={0.08}
        data-testid="landing-highlights"
      >
        {pt.landing.highlights.map((item, index) => {
          const Icon = ICONS[index];
          return (
            <StaggerItem
              key={item.title}
              data-testid={`landing-highlight-${index}`}
              className="flex flex-col gap-space-3 rounded-ds-lg bg-card p-space-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-ds-md bg-sage-100 text-sage-800 dark:bg-sage-900/50 dark:text-sage-200">
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <h3 className="font-display text-type-display-stat font-semibold text-foreground">
                {item.title}
              </h3>
              <p className="type-body-sm text-muted-foreground">{item.description}</p>
            </StaggerItem>
          );
        })}
      </StaggerGroup>
    </section>
  );
}
